import React__default from 'react';
import PropTypes from 'prop-types';

function PanelTitle(props) {
  var children = props.children,
    content = props.content,
    action = props.action,
    className = props.className,
    normalWeight = props.normalWeight;
  var size = props.size;
  var allowedSizes = ['small', 'normal', 'large', 'xlarge'];
  size = allowedSizes.some(function (validSize) {
    return validSize === size;
  }) ? "size-".concat(size) : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: "panel-title-wrapper ".concat(className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "panel-title ".concat(size, " ").concat(normalWeight ? 'normal-weight' : '')
  }, content || children), action ? /*#__PURE__*/React__default.createElement("div", {
    className: "panel-title-action"
  }, action) : null);
}
PanelTitle.defaultProps = {
  children: '',
  content: '',
  action: '',
  className: '',
  size: 'normal',
  normalWeight: false
};
PanelTitle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  action: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.string,
  size: PropTypes.string,
  normalWeight: PropTypes.bool
};

export default PanelTitle;
//# sourceMappingURL=PanelTitle.js.map
